var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { "data-component": "app-launcher-root" } },
    [
      _c("app-launcher-initializer", {
        attrs: { "is-ready": _vm.isAuthorized },
        on: { "sign-out": _vm.onSignOut },
      }),
      _vm._v(" "),
      _c("ExpirationOverlay", {
        class: { "is-authorized": !_vm.cookiesExpired },
        attrs: {
          "data-component": "expiration-overlay",
          "is-opened": _vm.cookiesExpired,
          "lock-username": _vm.usernameLockScreen,
          username: _vm.username,
          "auth-url": _vm.authUrl,
          "identity-provider": _vm.identityProvider,
          token: _vm.token,
          "user-id": _vm.userId,
          "account-id": _vm.accountId,
          "cookies-expired": _vm.cookiesExpired,
          "cookies-another-user": _vm.cookiesAnotherUser,
          "cookies-no-rights": _vm.cookiesNoRights,
          "login-overlay-disabled": false,
        },
        on: { onUpdateCookieExpiration: _vm.onUpdateCookieExpirationEvent },
      }),
      _vm._v(" "),
      _c("CommonWidgetsProvider"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }